import ApiRequest from './ApiRequest';
import ajaxUtils from '../util/ajax';
import { Timer } from '../util/Timer';
import { TIMER_NAME, TIMER_TYPE } from '../constants';
import timingTracker from "../Tracking/TimingTracker";

let trackingProviders = [];

module.exports = (storeUtils = window.flex) => {

    const { getApiUrl } = ajaxUtils(storeUtils);
    const TimingTracker = timingTracker({ ...storeUtils, Timer });

    class FlexApiRequest extends ApiRequest {
        constructor(params = {}) {
            const {
                track = FlexApiRequest.getTrackingProviders().reduce((output, provider) => {
                    return output || !!window[provider];
                }, false),
                path,

                ...passThroughParams
            } = params;


            const relativePath = FlexApiRequest.trimPath(path);
            const apiPath = getApiUrl(relativePath);
            const pathParts = relativePath.split('/');
            const parameters = Object.assign({}, passThroughParams, {
                path: apiPath,
                longRunningRequestInterval: params.longRunningRequestInterval || 10000
            });
            super(parameters);

            this.action = pathParts.length ? pathParts[pathParts.length - 1] : '';
            this.service = pathParts.length && pathParts.length - 2 >= 0 ? pathParts[pathParts.length - 2] : '';
            this.apiPath = apiPath;
            this.relativePath = relativePath;
            this.track = track;
        }

        static trimPath(path) {
            if (!path || typeof (path) !== 'string') {
                console.warn(`Invalid path: ${path} provided to FlexApiRequest`);
                return '/';
            }
            return `/${path.replace(/^[\s\uFEFF\xA0\/]+|([\s\uFEFF\xA0\/]+)$/g, '')}`;
        }

        static addTrackingProvider(provider) {
            // If provider is already loaded, no need to add it again
            if (typeof (provider) !== 'string' || !provider || trackingProviders.includes(provider)) {
                return;
            }
            trackingProviders.push(provider);
        }

        static getTrackingProviders() {
            return trackingProviders.slice(0);
        }

        _trackGeneric({ requestId, payload, requestConfig, timer }, timerType, addMetadata) {
            if (!this.track) {
                return;
            }
            try {
                let tracker = this.initTracker(requestId, timerType, timer);
                if (typeof (addMetadata) === 'function') {
                    addMetadata(tracker);
                }
                tracker.track();
            } catch (ex) {
                console.error(`Error in \`${this.constructor.name}.track.${timerType}\`\n`, ex);
            }
        }

        handleBeforeRequestSend({ requestId, payload, requestConfig, timer }) {
            super.handleBeforeRequestSend(...arguments);
            this._trackGeneric({ requestId, payload, requestConfig, timer }, TIMER_TYPE.BEGIN_REQUEST);
        }

        handleLongRunningRequestInterval({ requestId, payload, requestConfig, timer }) {
            super.handleLongRunningRequestInterval(...arguments);
            this._trackGeneric({ requestId, payload, requestConfig, timer }, TIMER_TYPE.LONG_RUNNING_REQUEST);
        }

        handleRequestCompleted({ requestId, payload, requestConfig, timer }) {
            super.handleRequestCompleted(...arguments);
            this._trackGeneric({ requestId, payload, requestConfig, timer }, TIMER_TYPE.REQUEST_COMPLETE);
        }

        handleRequestError({ requestId, error, payload, requestConfig, timer }) {
            super.handleRequestError(...arguments);
            if (!this.track) {
                return;
            }
            let {
                errorThrown,
                jqXHR,
                textStatus: status
            } = error;
            let errors;

            if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.errors) {
                errors = JSON.stringify(jqXHR.responseJSON.errors);
            }

            this._trackGeneric({ requestId, payload, requestConfig, timer }, TIMER_TYPE.REQUEST_ERROR, (tracker) => {
                tracker.addMetadata('Request', {
                    errorThrown,
                    errors,
                    status,
                    payload: JSON.stringify(payload)
                });
            });
        }

        initTracker(requestId, timerType, timer) {
            let tracker = new TimingTracker(this.action);
            tracker.addTimer(TIMER_NAME.REQUEST, timer);
            tracker.addMetadata('Request', {
                constructor: this.constructor.name,
                id: requestId,
                endpoint: this.relativePath,
                url: this.apiPath,
                service: this.service
            });
            tracker.addMetadata('Timing', {
                type: timerType
            });

            return tracker;
        }
    }

    return FlexApiRequest;
};